import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DubniumBaseContainerFlex } from '@adornis/digitale-helden-shared/db/buildify/container/DubniumBaseContainerFlex.js';

@Entity()
export class BaseFullsizeContainer extends DubniumBaseContainerFlex {
  static override _class = 'BaseFullsizeContainer';

  @Field(type => String) backgroundImageID: Maybe<string>;
  @Field(type => String) backgroundSize: Maybe<string>;
  @Field(type => String) backgroundRepeat: Maybe<string>;
  @Field(type => String) backgroundPosition: Maybe<string>;
}
